export const CommissionModel = {
    DEFAULT: 0,
    GROUP: 1,
    INDIVIDUAL: 2,
    /**
     * @deprecated
     */
    COUPON_BASE: 3,
    TRANSACTION_TIER: 4,
    CATEGORY_BASE: 5,
    PRODUCT_BASE: 6,
    GLOBAL_COMMISSION_RULE: 7,
    INDIVIDUAL_COMMISSION_RULE: 8,
}

export const CommissionAmountType = {
    PERCENT: 0,
    AMOUNT: 1,
}

export const CommissionActionType = {
    SET_PERCENTAGE: 0,
    SET_FLAT_AMOUNT: 1,
    MULTIPLY_BY: 2,
    ADD_FLAT_AMOUNT: 3,
    ADD_PERCENTAGE: 4,
    BONUS_PERCENTAGE: 5,
    BONUS_FLAT_AMOUNT: 6,
}

export const CommissionConditionPerformanceMetricsID = {
    NUMBER_OF_SALES_LAST_MONTH: 0,
    NUMBER_OF_SALES_THIS_MONTH: 1,
    NUMBER_OF_SALES_TODAY: 2,
    SALE_COMMISSIONS_LAST_MONTH: 3,
    SALE_COMMISSIONS_THIS_MONTH: 4,
    SALE_COMMISSIONS_TODAY: 5,
    NUMBER_OF_LEADS_LAST_MONTH: 6,
    NUMBER_OF_LEADS_THIS_MONTH: 7,
    NUMBER_OF_LEADS_TODAY: 8,
    LEAD_COMMISSIONS_LAST_MONTH: 9,
    LEAD_COMMISSIONS_THIS_MONTH: 10,
    LEAD_COMMISSIONS_TODAY: 11,
    // NUMBER_OF_BONUSES_LAST_MONTH: 12,
    // NUMBER_OF_BONUSES_THIS_MONTH: 13,
    // NUMBER_OF_BONUSES_TODAY: 14,
    // BONUS_COMMISSIONS_LAST_MONTH: 15,
    // BONUS_COMMISSIONS_THIS_MONTH: 16,
    // BONUS_COMMISSIONS_TODAY: 17,
    // NUMBER_OF_LEAPFROGS_LAST_MONTH: 18,
    // NUMBER_OF_LEAPFROGS_THIS_MONTH: 19,
    // NUMBER_OF_LEAPFROGS_TODAY: 20,
    // LEAPFROG_COMMISSIONS_LAST_MONTH: 21,
    // LEAPFROG_COMMISSIONS_THIS_MONTH: 22,
    // LEAPFROG_COMMISSIONS_TODAY: 23,
    COMMISSIONS_FOR_THE_CURRENT_MONTH: 24,
    COMMISSIONS_TOTAL: 25,
    GROSS_SALES_IN_THE_CURRENT_MONTH: 26,
    GROSS_SALES_TOTAL: 27,
    NET_SALES_IN_THE_CURRENT_MONTH: 28,
    NET_SALES_TOTAL: 29,
    // NUMBER_OF_SALES_IN_THE_CURRENT_MONTH: 30,
    NUMBER_OF_SALES_TOTAL: 31,
    HITS_IN_THE_CURRENT_MONTH: 32,
    SALE_AMOUNT: 33,
    GROSS_SALES_LAST_MONTH: 34,
    NET_SALES_LAST_MONTH: 35,
    HITS_LAST_MONTH: 36,
    COMMISSIONS_LAST_MONTH: 39,
    // NUMBER_OF_SALES_AND_LEAPFROGS_LAST_MONTH: 40,
    // NUMBER_OF_SALES_AND_LEAPFROGS_THIS_MONTH: 41,
    // NUMBER_OF_SALES_AND_LEAPFROGS_TODAY: 42,
    // SALE_AND_LEAPFROG_COMMISSIONS_LAST_MONTH: 43,
    // SALE_AND_LEAPFROG_COMMISSIONS_THIS_MONTH: 44,
    // SALE_AND_LEAPFROG_COMMISSIONS_TODAY: 45,
}

export const CommissionConditionID = {
    ...CommissionConditionPerformanceMetricsID,

    ORDER_NUMBER: 46,
    CONVERSION_DATE: 47,
    CONVERSION_TYPE: 48,
    ORDER_TOTAL: 49,
    COUPON_CODE_MATCH: 50,
    COUPON_CODE_USAGE: 51,
    COUPON_CODE_AVAILABLITY: 52,

    AFFILIATE_JOIN_MATCH: 53,
    AFFILIATE_JOIN_DURATION_MATCH: 54,

    LEAD_FORM_ID: 59,
}

export const CommissionOperand = {
    START_WITH: 0,
    CONTAINS: 1,
    EQUAL: 2,
    END_WITH: 3,
    IN_LIST: 4,
    NOT_IN_LIST: 5,
    BETWEEN: 6,
    GREATER_THAN: 7,
    GREATER_THAN_EQUAL: 8,
    LESS_THAN: 9,
    LESS_THAN_EQUAL: 10,
}

export const CommissionType = {
    LEAD: 1,
    SALE: 5,
    MIX: 9,
    NONE: 13,
}

export const CommissionTierType = {
    FIXED: 0,
    MULTIPLIER: 1,
}

export const CommissionMetricBase = {
    COMMISSIONS_FOR_THE_CURRENT_MONTH: 0,
    COMMISSIONS_TOTAL: 1,
    GROSS_SALES_IN_THE_CURRENT_MONTH: 2,
    GROSS_SALES_TOTAL: 3,
    NET_SALES_IN_THE_CURRENT_MONTH: 4,
    NET_SALES_TOTAL: 5,
    NUMBER_OF_SALES_IN_THE_CURRENT_MONTH: 6,
    NUMBER_OF_SALES_TOTAL: 7,
    HITS_IN_THE_CURRENT_MONTH: 8,
    SALE_AMOUNT: 9,
    GROSS_SALES_LAST_MONTH: 10,
    NET_SALES_LAST_MONTH: 11,
    HITS_LAST_MONTH: 12,
    COMMISSIONS_LAST_MONTH: 13,
    NUMBER_OF_SALES_LAST_MONTH: 14,
}